<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table
        ref="dataTable"
        :headers="headers"
        :items="getDataTable"
        :search="search"
        sort-by="descricao"
      >
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="search"
                label="Procurar..."
                prepend-inner-icon="mdi-magnify"
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.entradaMinima`]="{ item }">{{
          item.entradaMinima | percent
        }}</template>


        <template v-slot:[`item.ativo`]="{ item }">
          <v-btn color="transparent" small fab depressed>
            <v-icon
              :color="item.ativo ? 'green' : 'red'"
              @click="
                $ability.can('Editar', 'Financiamento') ? updateAtivo(item) : ''
              "
              >{{ item.ativo ? "mdi-check" : "mdi-close" }}</v-icon
            >
          </v-btn>
        </template>

        <template v-slot:[`item.acoes`]="{ item }">
          <v-tooltip v-if="$ability.can('Ver Prazos', 'Financiamento')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogTablePrazos.show({ ...item })"
              >
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            Prazos
          </v-tooltip>
          <v-tooltip
            v-if="$ability.can('Vincular Veiculos', 'Financiamento')"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.vincularProdutoForca.show({ ...item })"
              >
                <v-icon>mdi-car</v-icon>
              </v-btn>
            </template>
            Vincular/Desvincular Veiculos
          </v-tooltip>
          <v-tooltip
            v-if="$ability.can('Vincular Empresas', 'Financiamento')"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.vincularEmpresas.show({ ...item })"
              >
                <v-icon>mdi-domain</v-icon>
              </v-btn>
            </template>
            Vincular/Desvincular Empresas
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Editar', 'Financiamento')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogFinanciamento.show(true, { ...item })"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            Editar Financiamento
          </v-tooltip>
        </template>
      </v-data-table>
      <DialogTablePrazos ref="dialogTablePrazos" />
      <VincularVeiculos
        ref="vincularProdutoForca"
        @updated="updateVeiculos($event)"
      />
      <VincularEmpresas
        ref="vincularEmpresas"
        @updated="updateEmpresas($event)"
      />
      <DialogFinanciamento
        ref="dialogFinanciamento"
        @updated="update($event)"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Financiamento from "@/services/financiamento";

export default {
  name: "Table",

  components: {
    DialogTablePrazos: () => import("./DialogTablePrazos"),
    VincularVeiculos: () => import("./VincularVeiculos"),
    VincularEmpresas: () => import("./VincularEmpresas"),
    DialogFinanciamento: () => import("./DialogFinanciamento")
  },

  data() {
    return {
      headers: [
        { text: "Tabela", value: "idBanco", align: "start" },
        { text: "Descrição", value: "descricao", align: "start" },
        { text: "Entrada Minima", value: "entradaMinima", align: "start" },
        { text: "Ativo", value: "ativo", sortable: false, align: "center" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" }
      ],
      search: "",
      serviceFinanciamento: new Financiamento()
    };
  },

  methods: {
    updateVeiculos(financiamento) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === financiamento.id
      );
      if (financiamento.veiculos.length === 0) {
        this.$refs.dataTable.items[index].veiculos = [];
      } else {
        this.$refs.dataTable.items[index].veiculos = financiamento.veiculos.map(
          veiculo => veiculo
        );
      }
    },

    updateEmpresas(financiamento) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === financiamento.id
      );
      if (financiamento.empresas.length === 0) {
        this.$refs.dataTable.items[index].empresas = [];
      } else {
        this.$refs.dataTable.items[index].empresas = financiamento.empresas.map(
          empresa => empresa
        );
      }
    },

    updateAtivo(financiamento) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === financiamento.id
      );
      let estadoInicial = financiamento.ativo;
      let texto = "";
      if (financiamento.ativo) {
        texto = `Deseja Desativar Tabela de Financiamento ${financiamento.descricao}?`;
      } else {
        texto = `Deseja Ativar Tabela de Financiamento ${financiamento.descricao}?`;
      }
      this.$swal.confirm(texto).then(async () => {
        try {
          financiamento.ativo = !financiamento.ativo;
          await this.serviceFinanciamento.update({ ...financiamento });
          await this.serviceFinanciamento.criaHistoricoAtualizacaoAtivo(
            { ...financiamento },
            this.getUser.nome
          );
          this.$refs.dataTable.items.splice(index, 1);
          return Promise.resolve();
        } catch (error) {
          financiamento.ativo = estadoInicial;
          await this.serviceFinanciamento.update({ ...financiamento });
          this.$toast.error(`Erro ao atualizar ativo`);
          return Promise.reject(error);
        }
      });
    },

    update(financiamento) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === financiamento.id
      );
      this.$refs.dataTable.items[index].ativo = financiamento.ativo;
      this.$refs.dataTable.items[index].descricao = financiamento.descricao;
      this.$refs.dataTable.items[index].entradaMinima =
        financiamento.entradaMinima;
    }
  },

  computed: {
    ...mapGetters("auth", ["getUser"]),
    ...mapGetters("financiamentoProdutoForca", ["getFinanciamentos"]),

    getDataTable() {
      return this.getFinanciamentos || [];
    }
  }
};
</script>
